import * as React from "react";
// eslint-disable-next-line import/no-extraneous-dependencies
import { Page, View } from "@react-pdf/renderer";
import { styles } from "./styles";
import { ISinglePro } from "../../../components/singlePro/state";
import { SinglePro } from "./SinglePro";
import { PageHeader } from "./Header";
import { PageFooter } from "./Footer";

interface Props {
  pros: Array<ISinglePro>;
}
export const SinglePage: React.FC<Props> = ({ pros }) => (
  <Page style={{ paddingBottom: "0px" }} size="A4">
    <PageHeader />
    <View style={styles.prosWrapper}>
      {pros.map((pro, index) => (
        <SinglePro pro={pro} key={index} />
      ))}
    </View>
    <PageFooter />
  </Page>
);
